import { Col, Container, Row } from "react-bootstrap";
import { motion } from "framer-motion";

import Depoimento from "../Depoimento";

export default function LandingDepoimentos(){

	return (
		<Container fluid id="depoimentos" className="py-5">
			<Container>
				<div className="mb-5 fs-1 text-white fw-bold text-center">Na nossa tribo, as recomendações dos clientes são a prova de um trabalho <span style={{whiteSpace: 'nowrap'}}>bem-sucedido.</span></div>
				<Row>
					<Col lg={4} className="mb-3">
						<motion.div initial={{opacity: 0.5, scale: 0.8}} whileInView={{opacity: 1, scale: 1}} transition={{type: "tween", duration: 0.5}} viewport={{margin: "-100px"}}>
							<Depoimento video={process.env.PUBLIC_URL+"videos/depoimento_1.mp4"} nome={"Juliano Portal"} texto={"Com a Tribo Barber eu só me preocupo em cortar o cabelo e atender bem o meu cliente."}/>
						</motion.div>
					</Col>
					<Col lg={4} className="mb-3">
						<motion.div initial={{opacity: 0.5, scale: 0.8}} whileInView={{opacity: 1, scale: 1}} transition={{type: "tween", duration: 0.5}} viewport={{margin: "-100px"}}>
							<Depoimento video={process.env.PUBLIC_URL+"videos/depoimento_2.mp4"} nome={"Gabriel Krech"} texto={"A Tribo Barber organizou minha agenda, horários e contabilidade!"}/>
						</motion.div>
					</Col>
					<Col lg={4} className="mb-3">
						<motion.div initial={{opacity: 0.5, scale: 0.8}} whileInView={{opacity: 1, scale: 1}} transition={{type: "tween", duration: 0.5}} viewport={{margin: "-100px"}}>
							<Depoimento video={process.env.PUBLIC_URL+"videos/depoimento_3.mp4"} nome={"Luan Pedroso"} texto={"Com a Tribo Barber eu consigo me dedicar exclusivamente ao meu cliente."}/>
						</motion.div>
					</Col>
				</Row>
			</Container>
		</Container>
	)
}